export const FETCH_NEWSLETTER_REQUEST = 'newsletter/FETCH_NEWSLETTER_REQUEST';
export const FETCH_NEWSLETTER_SUCCESS = 'newsletter/FETCH_NEWSLETTER_SUCCESS';
export const FETCH_NEWSLETTER_FAILURE = 'newsletter/FETCH_NEWSLETTER_FAILURE';

export const FETCH_SURVEY_REQUEST = 'newsletter/FETCH_SURVEY_REQUEST';
export const FETCH_SURVEY_SUCCESS = 'newsletter/FETCH_SURVEY_SUCCESS';
export const FETCH_SURVEY_FAILURE = 'newsletter/FETCH_SURVEY_FAILURE';

export const FETCH_INDIVIDUAL_REQUEST = 'newsletter/FETCH_INDIVIDUAL_REQUEST';
export const FETCH_INDIVIDUAL_SUCCESS = 'newsletter/FETCH_INDIVIDUAL_SUCCESS';
export const FETCH_INDIVIDUAL_FAILURE = 'newsletter/FETCH_INDIVIDUAL_FAILURE';

export const FETCH_TARGET_REQUEST = 'newsletter/FETCH_TARGET_REQUEST';
export const FETCH_TARGET_SUCCESS = 'newsletter/FETCH_TARGET_SUCCESS';
export const FETCH_TARGET_FAILURE = 'newsletter/FETCH_TARGET_FAILURE';

export const CREATE_RESPONSE_REQUEST = 'newsletter/CREATE_RESPONSE_REQUEST';
export const CREATE_RESPONSE_SUCCESS = 'newsletter/CREATE_RESPONSE_SUCCESS';
export const CREATE_RESPONSE_FAILURE = 'newsletter/CREATE_RESPONSE_FAILURE';

export const UPDATE_RESPONSE_REQUEST = 'newsletter/UPDATE_RESPONSE_REQUEST';
export const UPDATE_RESPONSE_SUCCESS = 'newsletter/UPDATE_RESPONSE_SUCCESS';
export const UPDATE_RESPONSE_FAILURE = 'newsletter/UPDATE_RESPONSE_FAILURE';

export const CLEAR_NEWSLETTER_ERROR = 'newsletter/CLEAR_NEWSLETTER_ERROR';
export const CLEAR_SURVEY_ERROR = 'newsletter/CLEAR_SURVEY_ERROR';
export const CLEAR_INDIVIDUAL_ERROR = 'newsletter/CLEAR_INDIVIDUAL_ERROR';
export const CLEAR_TARGET_ERROR = 'newsletter/CLEAR_TARGET_ERROR';

export const INIT_TARGET = 'newsletter/INIT_TARGET';

export const INIT_INDIVIDUAL = 'newsletter/INIT_INDIVIDUAL';

export const INIT_RESPONSE = 'newsletter/INIT_RESPONSE';

export const INIT_NEWSLETTERS = 'newsletter/INIT_NEWSLETTERS';

export const fetchNewsletterRequest = (payload = {}) => ({
  type: FETCH_NEWSLETTER_REQUEST,
  payload,
});
export const fetchNewsletterSuccess = (payload = {}) => ({
  type: FETCH_NEWSLETTER_SUCCESS,
  payload,
});
export const fetchNewsletterFailure = (payload = {}) => ({
  type: FETCH_NEWSLETTER_FAILURE,
  payload,
});

export const fetchSurveyRequest = (payload = {}) => ({
  type: FETCH_SURVEY_REQUEST,
  payload,
});
export const fetchSurveySuccess = (payload = {}) => ({
  type: FETCH_SURVEY_SUCCESS,
  payload,
});
export const fetchSurveyFailure = (payload = {}) => ({
  type: FETCH_SURVEY_FAILURE,
  payload,
});

export const fetchIndividualRequest = (payload = {}) => ({
  type: FETCH_INDIVIDUAL_REQUEST,
  payload,
});
export const fetchIndividualSuccess = (payload = {}) => ({
  type: FETCH_INDIVIDUAL_SUCCESS,
  payload,
});
export const fetchIndividualFailure = (payload = {}) => ({
  type: FETCH_INDIVIDUAL_FAILURE,
  payload,
});

export const fetchTargetRequest = (payload = {}) => ({
  type: FETCH_TARGET_REQUEST,
  payload,
});
export const fetchTargetSuccess = (payload = {}) => ({
  type: FETCH_TARGET_SUCCESS,
  payload,
});
export const fetchTargetFailure = (payload = {}) => ({
  type: FETCH_TARGET_FAILURE,
  payload,
});

export const createResponseRequest = (payload = {}) => ({
  type: CREATE_RESPONSE_REQUEST,
  payload,
});
export const createResponseSuccess = (payload = {}) => ({
  type: CREATE_RESPONSE_SUCCESS,
  payload,
});
export const createResponseFailure = (payload = {}) => ({
  type: CREATE_RESPONSE_FAILURE,
  payload,
});

export const updateResponseRequest = (payload = {}) => ({
  type: UPDATE_RESPONSE_REQUEST,
  payload,
});
export const updateResponseSuccess = (payload = {}) => ({
  type: UPDATE_RESPONSE_SUCCESS,
  payload,
});
export const updateResponseFailure = (payload = {}) => ({
  type: UPDATE_RESPONSE_FAILURE,
  payload,
});

export const clearNewsletterError = () => ({
  type: CLEAR_NEWSLETTER_ERROR,
});
export const clearSurveyError = () => ({
  type: CLEAR_SURVEY_ERROR,
});
export const clearIndividualError = () => ({
  type: CLEAR_INDIVIDUAL_ERROR,
});
export const clearTargetError = () => ({
  type: CLEAR_TARGET_ERROR,
});

export const initTarget = (payload = {}) => ({
  type: INIT_TARGET,
  payload,
});

export const initIndividual = (payload = {}) => ({
  type: INIT_INDIVIDUAL,
  payload,
});

export const initResponse = (payload = {}) => ({
  type: INIT_RESPONSE,
  payload,
});

export const initNewsletter = (payload = {}) => ({
  type: INIT_NEWSLETTERS,
  payload,
});
